










import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {FieldStyleContext} from '@/fields/field-style-context';

/**
 * Simple Component for fast field content rendering
 *
 * Supports a simple text given as value
 */
@Component
export default class AmetrasSimpleTextOutputTemplate extends Vue {

  @Prop() textAlign!: 'LEFT' | 'RIGHT' | 'CENTER' | 'JUSTIFIED';
  @Prop() marginDefinition!: string;
  @Prop() paddingDefinition!: string;
  @Prop() value!: string | number | boolean;
  @Prop() styleContext!: FieldStyleContext;

}

